/**
 * Created by andrey on 02.08.2022
 */

const BeforeOutcomeAction = function () {
    const scene = cleverapps.Scenes.GetRunningScene();
    if (scene.startMusicAction && !scene.startMusicAction.isDone()) {
        scene.stopAction(scene.startMusicAction);
        delete scene.startMusicAction;
    }
    if (!this.shouldSkipVictoryWindow()) {
        cleverapps.audio.fadeOutAndEject();
    }
    cleverapps.placements.run(Placements.AFTER_GAME_FINISH);

    const outcome = this.outcome;
    if (outcome === GameBase.OUTCOME_VICTORY || outcome === GameBase.OUTCOME_GAVEUP) {
        this.giveLife();
    }

    if (this.level.isRegular() && cleverapps.isKnockoutGame()) {
        cleverapps.knockoutGame.rumble.moveNextRound(outcome);
    }

    if (this.getMode() === GameBase.MODE_HIGHSCORE) {
        cleverapps.highscore.gamePlayed(this);
    }

    if (cleverapps.focusManager.focus === "KeypadControl") {
        this.keypad.reset();
    }

    const lantern = typeof Lantern !== "undefined" && Lantern.Get();
    if (lantern && lantern.isActive(this.level)) {
        lantern.onChangeOutcome(outcome);
    }

    if (cleverapps.GameSaver && outcome !== GameBase.OUTCOME_GAVEUP) {
        cleverapps.GameSaver.remove(this.level.episodeNo, this.level.levelNo);
    }

    if (outcome === GameBase.OUTCOME_VICTORY) {
        BeforeWinAction.call(this);
    }

    if (outcome === GameBase.OUTCOME_LOST) {
        GameBase.levelLostHash = this.level.hash;
    }
};

const BeforeWinAction = function () {
    const getLevelTimePeriod = (passedTime) => {
        const LEVEL_MINUTES_GRID = [1, 2, 4, 8, 16, 32, 64, 128, 256];
        const minutes = passedTime / 1000 / 60;

        for (const v in LEVEL_MINUTES_GRID) {
            if (minutes < LEVEL_MINUTES_GRID[v]) {
                return LEVEL_MINUTES_GRID[v];
            }
        }
        return 512;
    };

    const passedTime = this.timer.getTime();
    const minutes = getLevelTimePeriod(passedTime);

    const timeParams = this.getLevelStatsParams();
    timeParams.value = minutes;
    timeParams.itemId = this.level.getTag() || "normal";

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_PASSED_TIME, timeParams);

    if (this.level.isRegular() || this.level.isBonusWorldLevel()) {
        if (this.leftMoves !== undefined) {
            const leftMoves = Math.min(Math.max(this.leftMoves || 0, 0), 30);
            const movesParams = this.getLevelStatsParams();
            movesParams.value = leftMoves;

            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_LEFT_MOVES, movesParams);
        }

        let levelFinish = true;
        if (cleverapps.config.type === "board") {
            levelFinish = this.timer.getTime() <= cleverapps.parseInterval("5 minutes");
        }
        if (levelFinish) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_FINISH, this.getLevelStatsParams());
        }

        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.UNIQUE_FINISH, this.getLevelStatsParams());

        if (this.level.isBonus()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.BONUS_LEVEL_FINISH);
        }
    }

    if (this.level.isBonusWorldLevel()) {
        cleverapps.missionManager.dispatchEvent(Mission.TYPE_BONUS_WORLD, { level: this.level });
    }

    if (this.level.isWeeklyTournamentLevel()) {
        cleverapps.weeklyTournament.onLevelPassed();
    }

    this.addBasicReward();
};
